import { DTOBase } from "./Dtobase";

export class Payment extends DTOBase{
    orderNumber: string;
    totalAmount: number;
    currencyCode: string;
    customerId: string;
}
export class TransactionStatus {
    transactionId: string;
    responseCode: string;
    customerId : string;
    customerEmail : string;
    promoCode : string;
    sessionId : string;
}

export class PaymentRegistration extends DTOBase {
    orderNo: string;
    currencyCode: string;
    amount: number;
    customerId: string;
    customerEmail : string;
    promoCode : string;
    sessionId : string;
}

export class CapturePaymentStatus extends DTOBase{
    transactionId : string;
    responseCode : string;
    customerId : string;
    orderId : string;
    amount : number;
    customerEmail : string;
    promoCode : string;
    sessionId : string;
}




// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/payment.ts